import { inversorApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'INVERSOR',
    api: inversorApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'INVERSOR',
  api: inversorApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'INVERSOR',
    api: inversorApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'INVERSOR',
    api: inversorApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'INVERSOR',
  api: inversorApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'INVERSOR',
    api: inversorApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('INVERSOR');
export const setDeletedPending = createListDataDeletedPending('INVERSOR');
